var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.589,
    height: 8.794,
    viewBox: "0 0 14.589 8.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    d: "M3156.241,3814.5l6.234,6.234,6.234-6.234",
    transform: "translate(-3155.181 -3813.439)",
    fill: "none",
    stroke: "#4eabe9",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowDown);
export default __webpack_public_path__ + "static/media/blue_arrow_down.b16a22a797f4be531e2788708ba81cc4.svg";
export { ForwardRef as ReactComponent };